"use strict";
/* globals module */
/**
 * @module applicationSettingsClient
 * @description  Application Settings Client provides an easy way to consume  Application Settings REST API end-points. In order to obtain needed routes `applicationSettingsClient` uses `applicationSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var ApplicationSettingsClient = /** @class */ (function () {
    function ApplicationSettingsClient(applicationSettingsRoute, apiClient) {
        this.applicationSettingsRoute = applicationSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ApplicationSettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `applicationSettingsRoute`.
         * @method
         * @example ApplicationSettingsClient.routeDefinition.get(options)
         **/
        get: function () {
            return this.applicationSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the application settings resource.
     * @method
     * @param options Query resource options object.
     * @example applicationSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ApplicationSettingsClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update application settings action has been performed. This action updates the application setting resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't use `applicationSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(appSettings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An application object used to update application settings of the specified application resource.
     * @example // appSettings is a resource previously fetched using get action.
                    appSettings.allowAnyOrigin = true;
                    applicationSettingsClient.update(appSettings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    ApplicationSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ApplicationSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ApplicationSettingsRoute !== "undefined" && _1.ApplicationSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ApplicationSettingsClient);
    return ApplicationSettingsClient;
}());
exports.ApplicationSettingsClient = ApplicationSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
